export default __webpack_public_path__ + "static/cert-5-f998fa21ba489a4b512ca735e70fdc6c.png";